// extracted by mini-css-extract-plugin
export default {"primary":"YxkHn","secondary":"RZbby","wrapper":"bWXE7","step-wrapper":"bXUo9","step-container":"WUEHj","step-circle":"YUcbw","texts-container":"exaVJ"};